import React from 'react';
import LibraryContext from '../LibraryContext';

export default function LibraryProvider(props) {
  const { children } = props;
  return <LibraryContext.Provider>{children}</LibraryContext.Provider>;
}
